module.exports = __webpack_public_path__ + "static/img/marker_red.62dd4a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shareHouse/marker_red.png
// module id = b5bl
// module chunks = 30